import { useEffect } from 'react'
import { useCookieConsentContext } from './CookieConsentContext'
import { useTracker } from 'src/lib/js/hooks/useTracker'
import { useFlags } from 'launchdarkly-react-client-sdk'

/**
 * This component handles cookie consent for Tracker.
 */
const TrackerConsentHandler = () => {
  const { ethycaInitialized, marketingConsent, analyticsConsent } =
    useCookieConsentContext()
  const tracker = useTracker()
  const { ooEthycaAds } = useFlags()

  useEffect(() => {
    if (!ethycaInitialized) {
      return
    }
    tracker.setConsent(analyticsConsent) // Original consent flag for Tracker events (Amplitude, Google Analytics, etc.)
    if (ooEthycaAds ?? false) {
      tracker.setAdsConsent(marketingConsent) // Setting the Ads Manager related consent here. Defaults to false, and gated by the ooEthycaAds flag.
    }
  }, [
    ethycaInitialized,
    analyticsConsent,
    marketingConsent,
    tracker,
    ooEthycaAds
  ])
  return null
}

export default TrackerConsentHandler
